import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cartnav container-fluid p-0 sticky-top" }
const _hoisted_2 = { class: "row w-100" }
const _hoisted_3 = { class: "col-4 d-flex justify-content-end" }
const _hoisted_4 = { class: "btn cartbutton position-relative" }
const _hoisted_5 = { class: "cartpill position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "col-4 d-flex align-items-center" }, null, -1)),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-4 text-center" }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/cart",
          class: _normalizeClass({ squiggle: _ctx.cartStore.addedToCart })
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("i", {
                class: _normalizeClass(["bi bi-cart fs-3", { squiggle: _ctx.cartStore.addedToCart }])
              }, null, 2),
              _createElementVNode("span", _hoisted_5, [
                _createTextVNode(_toDisplayString(_ctx.cartStore.cart.length) + " ", 1),
                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "visually-hidden" }, "items in cart", -1))
              ])
            ])
          ]),
          _: 1
        }, 8, ["class"])
      ])
    ])
  ]))
}